import { trackifyInit } from '@allianz/tracking';
import { GetTheme, ThemeProvider } from '@arp/react-ndbx';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React, { useMemo } from 'react';
import AppRouter from 'src/routes/index';
import { TestBridge } from 'src/testing/TestBridge';
import { useAppVersion } from 'src/versioning/VersionContext';

//** Generic Error Modal */
import GenericErrorModal from './components/pageLevel/genericErrorModal/GenericErrorModal';
import ScrollToTop from './components/ScrollToTop';
import { TRACKIFY_EVENT } from './config/const/enums';
import useInjectionDetection from './hooks/useInjectionDetection';
import { RouteDebug } from './RouteDebug';

//* ----------------------------------------------------------------

// App.jsx (only the relevant part)
function App() {
  const defaultTheme = GetTheme();
  const queryClient = new QueryClient({});

  const version = useAppVersion();

  const isOnline = useMemo(() => {
    console.log('Determining version...'); // For debugging
    return version === 'v2-online';
  }, [version]);

  // const TestBridge =
  //   import.meta.env.MODE === 'test' ? lazy(() => import('./testing/TestBridge')) : null;

  trackifyInit({
    appName: TRACKIFY_EVENT.TRACKIFY_APP_NAME,
    pageId: TRACKIFY_EVENT.TRACKIFY_PAGE_ID,
  });

  //** Check for unexpected script injected */
  useInjectionDetection();
  return (
    <ThemeProvider theme={defaultTheme}>
      <QueryClientProvider client={queryClient}>
        {/* {TestBridge && (
          <Suspense fallback={null}>
            <TestBridge />
          </Suspense>
        )} */}
        <RouteDebug />
        <TestBridge />
        <ScrollToTop />
        <AppRouter isOnline={isOnline} />
        <ReactQueryDevtools initialIsOpen={true} />
      </QueryClientProvider>
      <GenericErrorModal />
    </ThemeProvider>
  );
}

export default App;
